import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
import { HERO_SIZES, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
const guarantees = ['Acceso inmediato', 'Para docentes de Hispanoamérica', 'Pago seguro'];
export function Hero() {
  return <header className="w-full bg-cream-100 px-6 pb-10 pt-5 sm:pt-7" data-id="element-86" data-mp="1297esbauxdd0">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-87" data-mp="127ec173d7daa">
        <span className="rounded-full bg-cream-200 px-5 py-1.5 text-xs font-semibold tracking-[0.22em] text-forest-700" data-id="element-88" data-mp="xb5slhi4wxxb">
          MEGA KIT INTEGRACIÓN CAMPO-PLC-SCADA 2026
        </span>

        <h1 className="mt-4 font-display text-4xl font-bold leading-[1.02] text-forest-800 sm:text-6xl lg:text-7xl" data-id="element-89" data-mp="nbooh4ij6s3g">
          Sensor a Sistema.
          <span className="block text-ember-500" data-id="element-90" data-mp="382fi9x3dfkj5">Todo conectado.</span>
        </h1>

        <img src={optimizedImage(HERO_IMAGE, 576)} srcSet={optimizedSrcSet(HERO_IMAGE, HERO_WIDTHS)} sizes={HERO_SIZES} alt="Los 6 volúmenes del Mega Kit Integración junto a los 6 bonos de implementación, plantillas imprimibles y laboratorios low-cost" width={1000} height={1000} fetchPriority="high" decoding="async" className="-my-4 h-auto w-full max-w-xl sm:-my-6" data-id="element-91" data-mp="384s4wnk2qj2j" />

        <p className="max-w-2xl text-base leading-relaxed text-forest-700/85 sm:text-lg" data-id="element-92" data-mp="30ggezjnzksic">
          Mega Kit Integración con 6 volúmenes técnicos, 6 bonos docentes e implementación profesional
          360°.
        </p>

        <ul className="mt-4 flex flex-col items-center gap-1.5 text-sm text-forest-600 sm:flex-row sm:gap-7 sm:text-base" data-id="element-93" data-mp="2qhqwboo9n411">
          {guarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-94" data-mp="2hkgj3xrw14th">
              <CheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-95" data-mp="2lkiiu1e2bo64" />
              {item}
            </li>)}
        </ul>

        <CtaButton className="mt-6" data-id="element-96" data-mp="s3mcu1g2bwxu" />

        <div className="mt-4 flex flex-col items-center gap-2 text-sm text-forest-700/85 sm:flex-row sm:gap-5" data-id="element-97" data-mp="nbbcixheu94r">
          <span className="flex items-center gap-2" data-id="element-98" data-mp="ibypabmmn01n">
            <span className="flex" aria-hidden="true" data-id="element-99" data-mp="ichyn3y7og42">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-100" data-mp="deyitzlv7va0" />)}
            </span>
            4.9/5 — +120 docentes
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-101" data-mp="162ufj4bfpn6s" />
          <span className="flex items-center gap-2" data-id="element-102" data-mp="111yagnfcjuzs">
            <ShieldCheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-103" data-mp="114ssy9esv5qk" />
            Garantía 7 Días
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-104" data-mp="3ltgltmwy8kmr" />
          <span className="flex items-center gap-2" data-id="element-105" data-mp="3hrdbj1m0nm32">
            <CreditCardIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-106" data-mp="3hpsen5c8br21" />
            Tarjeta · Mercado Pago · Transfer
          </span>
        </div>
      </div>
    </header>;
}